import React, { Component, ReactNode } from 'react';
import { Button, Modal, Select } from 'antd';
import cx from 'classnames';
import Icon from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as ChevronIconSVG } from '../../../assets/sightx-icons/svg/icon-chevron.svg';
import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';

import styles from './removeSeats.module.scss';
interface ILocalState {
  seatsToRemove: number;
}

interface IExternalProps {
  visible: boolean;
  seatsPurchased: number;
  seatsUsed: number;
  handleSelectUsers: (seatsToRemove: number) => void;
  handleCancel: () => void;
  handleRequireConfirmation: () => void;
}

type Props = IExternalProps;

export class RemoveUnusedSeatsModal extends Component<Props, ILocalState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      seatsToRemove: 1
    };
    this.handleNextAction = this.handleNextAction.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }

  private handleNextAction() {
    const { seatsUsed, seatsPurchased, handleRequireConfirmation, handleSelectUsers } = this.props;
    const { seatsToRemove } = this.state;
    const unusedSeats = seatsPurchased - seatsUsed;
    handleSelectUsers(seatsToRemove);
    if (seatsToRemove <= unusedSeats) {
      handleRequireConfirmation();
      return;
    }
  }

  private handleSelectionChange(seatsToRemove: number) {
    this.setState({ seatsToRemove });
  }

  private getSeatOrSeats(quantity: number): string {
    return (quantity === 1) ? 'seat' : 'seats';
  }

  render(): ReactNode {
    const { visible, seatsPurchased, seatsUsed, handleCancel } = this.props;
    const { seatsToRemove } = this.state;
    const options = Array.from({ length: seatsPurchased - 1 }, (_, index) => ({ value: index + 1 }));
    const remainingSeats = seatsPurchased - seatsToRemove;

    return <Modal
      visible={visible}
      title="Remove Seats"
      footer={null}
      width={450}
      closeIcon={<Icon className={styles.closeIcon} component={CrossSVG} />}
      onCancel={handleCancel}
      className={styles.modal}
      maskClosable={false}
    >
      <div className={styles.row}>
        <div className={styles.description}>
          Select the number of seats you would like to remove.
          <br />
          You are currently using <b>{seatsUsed}</b> of <b>{seatsPurchased}</b> seats in your subscription.
        </div>
        <Select
          className={styles.select}
          options={options}
          onChange={this.handleSelectionChange}
          value={this.state.seatsToRemove}
          suffixIcon={<Icon component={ChevronIconSVG} />}
        />
      </div>
      <div className={styles.description}>
        You are removing <b>{seatsToRemove}</b> {this.getSeatOrSeats(seatsToRemove)}, bringing you to a total of <b>{remainingSeats}</b> {this.getSeatOrSeats(remainingSeats)} in your subscription.
      </div>
      <div className={styles.supportingText}>
        Charges will take effect in your next billing cycle.
      </div>
      <div className={cx(styles.row, styles.actions)}>
        <Button className={styles.button} type='ghost' onClick={this.props.handleCancel}>Cancel</Button>
        <Button className={styles.button} type='primary' onClick={this.handleNextAction}>Next</Button>
      </div>
    </Modal>;
  }
}
